import Button from '@components/button/Button';
import Icon from '@components/icon/Icon';
import { getWalkthroughDetails, WalkthroughItem } from '@constants/generic';
import Modal from '@layouts/modal/Modal';

interface WalkthroughProps {
  handleSkip: () => void;
  currentHint: WalkthroughItem;
  handlePrimaryAction: () => void;
  userName: string;
  isLoading: boolean;
}

const WalkThroughModal = ({
  currentHint,
  handlePrimaryAction,
  handleSkip,
  userName,
  isLoading
}: WalkthroughProps) => {
  const { title, description, image, buttonLabel } = getWalkthroughDetails(
    currentHint,
    userName
  );

  return (
    <Modal isOpen className="w-112 max-w-500 !bg-cofeeNeutral1">
      <div className="flex flex-col items-center p-6 text-center">
        <div className="text-2xl font-semibold text-cofeeNeutral10">
          {title}
        </div>

        <Icon name={image || ''} size="none" className="my-3" />

        <p className="text-lg font-medium text-cofeeNeutral10">{description}</p>

        <div className="mt-6 flex w-full items-center justify-center gap-2">
          <Button
            variant="tertiary"
            label="Skip"
            handleClick={handleSkip}
            className="!h-11 w-full"
            size="small"
          />
          <Button
            variant="primary"
            label={buttonLabel}
            handleClick={handlePrimaryAction}
            className="!h-11 w-full"
            size="small"
            loading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default WalkThroughModal;
